import { defineMessages } from 'react-intl';

export const SignupFormMessages = defineMessages({
  emailEmpty: {
    id: 'signup.form.email.empty',
    defaultMessage: 'Please enter an email address',
    description: '',
  },
  emailPlaceholder: {
    id: 'signup.form.email.placeholder',
    defaultMessage: 'Enter your email',
    description: '',
  },
  emailLabel: {
    id: 'signup.form.email.label',
    defaultMessage: 'Email',
    description: 'Label for the email input',
  },
  signupDisplayNameEmpty: {
    id: 'signup.display.name.empty',
    defaultMessage: 'Full name must not be empty',
  },
  signupDisplayNameTooLong: {
    id: 'signup.display.name.too.long',
    defaultMessage: 'Full name must not be greater than 255 characters',
  },
  signupEmailFormatError: {
    id: 'signup.email.format.error',
    defaultMessage: 'Email is required to be in correct format',
  },
  signupEmailReachedMaxAliases: {
    id: 'signup.email.reached.max.aliases',
    defaultMessage: 'Email aliases are rate limited',
  },
  signupEmailRestrictedDomain: {
    id: 'signup.email.restricted.domain.error',
    defaultMessage: 'The provided email address is not allowed, please use a different one',
  },
  signupEmailBansNotAllowed: {
    id: 'signup.email.bans.not.allowed',
    defaultMessage: 'The provided email address is not allowed, please use a different one',
  },
  signupGenericFailure: {
    id: 'signup.failure',
    defaultMessage:
      'We are unable to sign you up. Please contact support and provide this message: {0}',
  },
  signupCaptchaResponseError: {
    id: 'signup.captcha.response.required.error',
    defaultMessage: "Are you sure you're not a robot?",
  },
});
